import dayjs from 'dayjs'
import Vue from 'vue'
import astonpages from '../../static/js/astonpage'
import { check_privilege, getPackageType } from '@/privileges.js'
export default {
  securityToken: function(state) {
    return 'BEARER ' + state.userid + ' ' + state.accessToken
  },
  isLoading: function(state) {
    return state.loading
  },
  isLoggedIn: function(state) {
    return state.isLoggedIn
  },
  availablePages: function(state) {
    let pagelist = []
    if (state.pagelist) {
      try {
        pagelist = state.pagelist
          .map(function(pageValue) {
            let isFound = false
            if (state.botlist) {
              isFound = state.botlist.find(function(botValue) {
                return (
                  botValue.pageid === pageValue.id || botValue.facebook_page_id === pageValue.id
                )
              })
            }
            return {
              ...pageValue,
              isInstalled: !isFound ? false : true
            }
            // return !isFound ? pageValue : null
          })
          .filter(el => el != null)
      } catch (error) {}
    }

    return pagelist
  },
  allPage: function(state) {
    let pagelist = []
    try {
      if (state.pagelist) {
        pagelist = state.pagelist.map(pageValue => {
          let bot = null
          if (state.botlist) {
            bot = state.botlist.find(botValue => {
              return botValue.pageid === pageValue.id
            })
          }

          pageValue.isInstallBot = bot || false
          return pageValue
        })
      }
    } catch (error) {}

    return pagelist
  },
  selectedBot: function(state) {
    if (state.selectedBot == null) {
      return null
    }

    var selectedBot = state.selectedBot

    try {
      var now = dayjs()
      var expriedDate = dayjs(state.selectedBot.expireat)
      selectedBot.expriedDate = parseInt(expriedDate.diff(now, 'days'))
      selectedBot.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
    } catch (error) {
      console.error(error)
    }

    try {
      var now = dayjs()
      var advancedExpriedDate = dayjs(state.selectedBot.advanced_expireat)
      selectedBot.advancedExpriedDate = parseInt(advancedExpriedDate.diff(now, 'days'))
      selectedBot.advancedExpriedTime = parseInt(advancedExpriedDate.diff(now, 'seconds'))
    } catch (error) {
      console.error(error)
    }
    try {
      const now = dayjs()
      const businessExpriedDate = dayjs(state.selectedBot.business_expireat)
      selectedBot.businessExpriedDate = parseInt(businessExpriedDate.diff(now, 'days'))
      selectedBot.businessExpriedTime = parseInt(businessExpriedDate.diff(now, 'seconds'))
    } catch (error) {
      console.error(error)
    }

    try {
      const now = dayjs()
      const livechatExpriedDate = dayjs(state.selectedBot.livechat_expireat)
      selectedBot.livechatExpriedDate = parseInt(livechatExpriedDate.diff(now, 'days'))
      selectedBot.livechatExpriedTime = parseInt(livechatExpriedDate.diff(now, 'seconds'))
    } catch (error) {
      console.error(error)
    }

    try {
      const now = dayjs()
      const googleExpriedDate = dayjs(state.selectedBot.google_message_expireat)
      selectedBot.googleExpriedDate = parseInt(googleExpriedDate.diff(now, 'days'))
      selectedBot.googleExpriedTime = parseInt(googleExpriedDate.diff(now, 'seconds'))
    } catch (error) {
      console.error(error)
    }

    try {
      const now = dayjs()
      const whatsappExpriedDate = dayjs(state.selectedBot.whatsapp_expireat)
      selectedBot.whatsappExpriedDate = parseInt(whatsappExpriedDate.diff(now, 'days'))
      selectedBot.whatsappExpriedTime = parseInt(whatsappExpriedDate.diff(now, 'seconds'))
    } catch (error) {
      console.error(error)
    }

    selectedBot.isUnlockLivechat = check_privilege('allin1chat', {
      bot: selectedBot
    })
    return selectedBot
  },
  selectedLivechatBot(state, getters) {
    try {
      var pageid = state.livechat.pageid
      if (!pageid || !getters.botlist) return null

      let bot = getters.botlist.find(b => b.pageid == pageid)
      return bot || { theme: 'ecommercebasic' }
    } catch (error) {
      console.error(error)
    }
  },
  botlist: function(state) {
    try {
      var bots = state.botlist.map(el => {
        try {
          let isUnlockLivechat = check_privilege('allin1chat', {
            bot: el
          })
          return {
            ...el,
            isUnlockLivechat: isUnlockLivechat
          }
        } catch (error) {
          return {
            ...el,
            isUnlockLivechat: false
          }
        }
      })
    } catch (error) {
      return []
    }

    return bots
  },
  isSelectedBot: function(state) {
    return state.isSelectedBot
  },
  paypalTrackingId: function(state) {
    return state.paypalTrackingId
  },
  setting: function(state) {
    return state.setting
  },
  getLivechatDetail: state => type => {
    switch (type) {
      case 'maxFetchUserTime':
        return state.livechat.maxFatchUserTime
    }
    return null
  },
  welcomeMessage2: (state, getters) => type => {
    var welcome_intent = state.welcomeMessage2
    let multichannel_welcome = false
    if (welcome_intent) {
      if (welcome_intent.fb_val || welcome_intent.line_val || welcome_intent.ig_val) {
        switch (type) {
          case 'facebook':
            try {
              multichannel_welcome = JSON.parse(welcome_intent.fb_val)
            } catch (error) {
              console.error(error)
            }
            break
          case 'line':
            try {
              multichannel_welcome = JSON.parse(welcome_intent.line_val)
            } catch (error) {
              console.error(error)
            }
            break
          case 'instagram':
            try {
              multichannel_welcome = JSON.parse(welcome_intent.ig_val)
            } catch (error) {
              console.error(error)
            }
            break
          case 'google':
            try {
              multichannel_welcome = JSON.parse(welcome_intent.google_val)
            } catch (error) {
              console.error(error)
            }
            break
          case 'whatsapp':
            try {
              multichannel_welcome = JSON.parse(welcome_intent.whatsapp_val)
            } catch (error) {
              console.error(error)
            }
            break
          default:
            break
        }
      }
    }
    if (multichannel_welcome) {
      return {
        multichannel: multichannel_welcome != false,
        messages: multichannel_welcome
      }
    }
    return {
      multichannel: false,
      messages:
        state.welcomeMessage && state.welcomeMessage.messages ? state.welcomeMessage.messages : [[]]
    }
  },
  welcomeMessage: (state, getters) => type => {
    var welcome_intent = getters.getIntents('welcome')
    let multichannel_welcome = false
    if (welcome_intent && welcome_intent.length > 0) {
      if (welcome_intent[0].fb_val || welcome_intent[0].line_val || welcome_intent[0].ig_val) {
        switch (type) {
          case 'facebook':
            try {
              multichannel_welcome = JSON.parse(welcome_intent[0].fb_val)
            } catch (error) {
              //
            }
            break
          case 'line':
            try {
              multichannel_welcome = JSON.parse(welcome_intent[0].line_val)
            } catch (error) {
              //
            }
            break
          case 'instagram':
            try {
              multichannel_welcome = JSON.parse(welcome_intent[0].ig_val)
            } catch (error) {
              //
            }
            break

          default:
            break
        }
      }
    }
    if (multichannel_welcome) {
      return {
        multichannel: multichannel_welcome != false,
        messages: multichannel_welcome
      }
    }
    return {
      multichannel: false,
      messages:
        state.welcomeMessage && state.welcomeMessage.messages ? state.welcomeMessage.messages : [[]]
    }
  },
  showModalWelcome: function(state) {
    return state.showModalWelcome
  },
  isFacebook: function(state) {
    return state.isFacebook
  },
  isCoachlab: function(state) {
    return state.selectedBot.pagetype == 'coachlab'
  },
  getPackage: function(state) {
    var bot = state.selectedBot
    let packages = getPackageType(bot)
    try {
      let privileges = packages.filter(el => {
        return ['premium', 'advanced', 'old_premium'].includes(el)
      })

      return privileges.length > 0 ? 'premium' : 'normal'
    } catch (error) {
      // console.log(error)
      return 'normal'
    }
  },
  currentLang: function(state) {
    return Vue.i18n.locale()
  },
  showAlert: state => type => {
    if (!state.selectedBot) {
      return -1
    }
    return state.alert.findIndex(function(el) {
      return el.name === type && el.pageid === state.selectedBot.pageid
    })
  },
  getCategories: function(state) {
    if (state.ecommerce.categories.length > 0) {
      state.ecommerce.categories = state.ecommerce.categories.filter(el => {
        if (state.selectedBot && !state.selectedBot.zortout_is_active) {
          return el.ref_code !== 'ZORTOUT'
        }
        return el
      })
    }
    return state.ecommerce.categories
  },
  getLoadingCategory: function(state) {
    return state.ecommerce.loadingCategory
  },
  getProducts: function(state) {
    if (state.ecommerce.products.length > 0) {
      state.ecommerce.products = state.ecommerce.products.filter(el => {
        if (state.selectedBot && !state.selectedBot.zortout_is_active) {
          if (el.ref_code) {
            return !el.ref_code.includes('ZORTOUT')
          }
        }
        return el
      })
    }
    return state.ecommerce.products
  },
  getLoadingProduct: function(state) {
    return state.ecommerce.loadingProduct
  },
  getTotalProduct: function(state) {
    return state.ecommerce.totalProduct
  },
  getUserTags: function(state) {
    return state.userTags
  },
  getLoadingUserTags: function(state) {
    return state.loadingUserTags
  },
  getUserStatus: function(state) {
    return state.userStatus
  },
  getLoadingUserStatus: function(state) {
    return state.loadingUserStatus
  },
  getLoadingSetting: function(state) {
    return state.loadingSetting
  },
  getSetting: function(state) {
    return state.setting
  },
  getLoadingCharges: function(state) {
    return state.ecommerce.loadingCharges
  },
  getCharges: function(state) {
    return state.ecommerce.charges
  },
  getLivechatUsers: function(state) {
    return type => {
      if (state.livechat && state.livechat.userlist[type]) {
        return state.livechat.userlist[type].users
      } else {
        return []
      }
    }
  },
  getCurrentUser: function(state) {
    return state.livechat.currentUser
  },
  allSchools: function(state) {
    return state.allSchools
  },
  getPageProfile: function(state) {
    return state.pageProfile
  },
  getLoadingPageProfile: function(state) {
    return state.loadingPageProfile
  },
  getLoadingPartnerProfile: function(state) {
    return state.loadingPartnerProfile
  },
  getPartnerProfile: function(state) {
    return state.partnerProfile
  },
  isLivechatSearching: function(state) {
    return !(
      state.livechat.filter.search == '' &&
      state.livechat.filter.tags.length == 0 &&
      state.livechat.filter.status == null &&
      state.livechat.filter.app == '' &&
      !state.livechat.filter.uuAreaName &&
      !state.livechat.filter.uu_name &&
      !state.livechat.filter.phoneno &&
      !state.livechat.filter.uu_register_status &&
      !state.livechat.filter.lastconversationtodate &&
      !state.livechat.filter.lastconversationtotime &&
      !state.livechat.filter.lastconversationfromdate &&
      !state.livechat.filter.lastconversationfromtime &&
      !state.livechat.filter.assignadminname &&
      !state.livechat.filter.session &&
      state.livechat.filter.filter_admin_read == null
    )
  },
  getShippingAddress: function(state) {
    if (state.selectedBot == null && state.selectedBot.shopaddressarray == null) {
      return null
    }
    try {
      return JSON.parse(state.selectedBot.shopaddressarray)
    } catch (error) {
      return null
    }
  },
  getLoadingAstonAdmins: function(state) {
    return state.loadingAstonAdmins
  },
  getAstonAdmins: function(state) {
    return state.astonAdmins
  },
  getLivechatSearching(state) {
    var result = Object.keys(state.livechat.filter).map(key => {
      return { name: key, value: state.livechat.filter[key] }
    }, [])
    return result.filter(el => {
      return (
        (el.value != '' &&
          el.value != null &&
          !(typeof el.value == Array && el.value.length == 0)) ||
        typeof el.value === 'boolean'
      )
    })
  },
  getDelayCustomerImport(state) {
    if (state.delayImportUserTime.length == 0) return true
    else {
      var delayTime = state.delayImportUserTime.find(el => {
        return el.pageid == state.selectedBot.pageid
      })
      if (delayTime) {
        var now = dayjs()
        var date = dayjs(delayTime.time)
        return parseInt(date.diff(now, 'seconds'))
      } else {
        return true
      }
    }
  },
  getLoadingIntents: function(state) {
    return state.loadingIntents
  },
  getIntents: state => type => {
    if (!state.intents) {
      return []
    }
    if (type) {
      switch (type) {
        case 'intent':
          return state.intents.filter(el => {
            return (
              el.context_in != 'comment' &&
              !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                el.intentname
              )
            )
          })
        case 'comment':
          return state.intents.filter(el => {
            return (
              el.context_in == 'comment' &&
              !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                el.intentname
              )
            )
          })
        default:
          return state.intents.filter(el => {
            return el.intentname == `{${type}}`
          })
      }
    } else return state.intents
  },
  getReportInboxMessage: function(state) {
    return state.reportInboxMessage
  },
  getReportReplyToComment: function(state) {
    return state.reportReplyToComment
  },
  getReportReplyToInbox: function(state) {
    return state.reportReplyToInbox
  },
  getReportHideToComment: function(state) {
    return state.reportHideToComment
  },
  getUnlockLivechat(state, getters) {
    var bot = getters.botlist.find(el => {
      return el.pageid == state.livechat.pageid
    })
    if (!bot) return window.aston.astonpages.includes(state.livechat.pageid) ? true : false
    return check_privilege('allin1chat', {
      bot: bot,
      livechatPageList: state.livechatPageList,
      livechatPageIdList: state.livechatPageIdList
    })
  },
  getLivechatUser(state) {
    let tags = state.livechat.user.tags
    if (tags) {
      const systemTags = {
        '{{slip_completed_1}}': 'ตรวจสลิป 1 ครั้ง',
        '{{slip_completed_more_than_1}}': 'ตรวจสลิปมากกว่า 1 ครั้ง',
      }
  
      for (const [key, value] of Object.entries(systemTags)) {
        tags = tags.replaceAll(key, value)
      }
    }
    return {...state.livechat.user, tags}
  },

  getMemberGroup(state) {
    return state.livechat.memberGroup
  },
  getBotPageRole: function(state, getters) {
    if (
      (state.selectedBot.packages.includes('line') &&
        !state.selectedBot.packages.includes('facebook')) ||
      getters.isZwizAdmin
    ) {
      return true
    } else if (
      state.selectedBot.packages.includes('line') &&
      state.selectedBot.packages.includes('facebook')
    ) {
      const bot_role = getters.allPage.find(function(val, index) {
        return val.id == state.selectedBot.facebook_page_id
      })

      if (bot_role) {
        if (bot_role.perms) {
          return bot_role.perms.indexOf('ADMINISTER') > -1
        } else if (bot_role.tasks) {
          return bot_role.tasks.indexOf('MANAGE') > -1
        }
        return null
      }
    } else if (
      !state.selectedBot.packages.includes('line') &&
      state.selectedBot.packages.includes('facebook')
    ) {
      const bot_role = getters.allPage.find(function(val, index) {
        return val.id == state.selectedBot.pageid
      })

      if (bot_role) {
        if (bot_role.perms) {
          return bot_role.perms.indexOf('ADMINISTER') > -1
        } else if (bot_role.tasks) {
          return bot_role.tasks.indexOf('MANAGE') > -1
        }
        return null
      }
    } else if (state.selectedBot.packages.includes('whatsapp')) {
      return true
    } else {
      return false
    }
  },
  isZwizAdmin(state) {
    try {
      return state.userid.includes('zwiz') && state.loginType == 'admin'
    } catch (error) {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js